module.exports = __webpack_public_path__ + "img/guangzhou.81e6274e.png";